import * as React from 'react';
import * as Moment from 'moment-timezone';
import classes from 'classnames';

export interface IDoomsdayDaysProps {
  days: IDaysState;
  tip: (day: number) => void;
}

export interface IDaysState {
  [key: number]: boolean | undefined;
}

export default class DoomsdayDays extends React.Component<IDoomsdayDaysProps> {

  constructor(props: IDoomsdayDaysProps) {
    super(props);
    this.button = this.button.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  public render() {
    return (
      <>
        <div className="row">
          <div className="col-12 text-center">
            {Moment().localeData().weekdays().map((elem, idx) => this.button(elem, idx))}
          </div>
        </div>
        <div className="row">
          <div className="col" />
          <div className="col-sm-12 col-md-4">
            <small>Use the keyboard to select the day (0 - Sunday)</small>
          </div>
          <div className="col" />
        </div>
      </>
    );
  }

  private button(label: string, day: number) {
    return (
      <button
        type="button"
        key={day}
        className={classes("btn btn-lg m-2 ml-2",
          {
            "btn-primary": this.props.days[day] === undefined,
            "btn-success": this.props.days[day] === true,
            "btn-danger": this.props.days[day] === false,
          }
        )}
        data-day={day}
        onClick={this.onClick}
      >
        {label}
        <span className="sr-only">{label}</span>
      </button>
    )
  }

  private onClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    const day = event.currentTarget.getAttribute("data-day");
    if (day) {
      this.props.tip(parseInt(day, 10));
    }
  }
}



// WEBPACK FOOTER //
// ./src/Doomsday/DoomsdayDays.tsx